import React, { Component } from 'react';
import { connect } from 'react-redux';
import { find, get } from 'lodash/fp';
import { EVENTS, TYPES } from 'constants/config';

class AssignView extends Component {
  constructor() {
    super();
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleAssignmentCreated = this.handleAssignmentCreated.bind(this);
  }

  componentDidMount() {
    pubsub.subscribe(EVENTS.ASSIGNMENT_CREATED, this.handleAssignmentCreated);
  }

  componentWillUnmount() {
    pubsub.unsubscribe(EVENTS.ASSIGNMENT_CREATED, this.handleAssignmentCreated);
  }

  handleAssignmentCreated(assignment) {
    const selfIdentity = { id: this.props.pathId, type: TYPES.PATH };
    const hasAssignedSelf = !!find(selfIdentity)(assignment.content);
    if (hasAssignedSelf) {
      this.props.onAssign();
    }
  }

  handleButtonClick() {
    pubsub.publish(EVENTS.ASSIGN_MODAL_TOGGLE);
  }

  render() {
    const { isCertification } = this.props;
    return (
      <div className="ReportingAssignView">
        <span className="ReportingAssignView-title">
          {isCertification
            ? t(
                'certifications.certification_builder.reporting.unassigned_title',
              )
            : 'Ready to assign this Path?'}
        </span>
        <p className="ReportingAssignView-description">
          {isCertification
            ? t(
                'certifications.certification_builder.reporting.unassigned_description',
              )
            : 'When you’re comfortable with your Path’s content, you can assign it to teammates.'}
        </p>
        <button
          type="button"
          children="Assign"
          className="NewButton NewButton--tallAndWide NewButton--yellow"
          onClick={this.handleButtonClick}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  pathId: pathBuilder.id,
  isCertification: !!get('certification')(pathBuilder),
});

export default connect(mapStateToProps)(AssignView);
